


import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function AuthRoute({ Component }: any) {
  const { session, isOnboardingFinished, username } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (session && username && !isOnboardingFinished) {
  

    }
  }, [session, username, isOnboardingFinished, navigate]); // Add navigate to the dependency array

  return <Component />;
}
